import React from 'react'

import i18n from 'live/services/i18n'

import { LoadMoreButtonContainer } from '../raListTableStyles'

interface LoadMoreButtonProps {
    totalReportsApproval: number
    reportsApprovalBeingDisplayed: number
    loadMoreReportsApproval: () => void
    loading: boolean
}

export function LoadMoreButton({
    totalReportsApproval,
    reportsApprovalBeingDisplayed,
    loadMoreReportsApproval,
    loading
}: LoadMoreButtonProps) {
    const reportsMissingToBeDisplayed =
        totalReportsApproval - reportsApprovalBeingDisplayed > 50
            ? 50
            : totalReportsApproval - reportsApprovalBeingDisplayed

    return loading ? (
        <LoadMoreButtonContainer>
            <span>loading...</span>
        </LoadMoreButtonContainer>
    ) : (
        <LoadMoreButtonContainer>
            <span>{`${i18n('Showing')} ${reportsApprovalBeingDisplayed} ${i18n('of')} ${totalReportsApproval} ${i18n(
                'reports'
            )}`}</span>
            {reportsApprovalBeingDisplayed < totalReportsApproval && (
                <button onClick={() => loadMoreReportsApproval()}>
                    <i className="fas fa-arrow-circle-down" />
                    <span>{`${i18n('Load more')} ${reportsMissingToBeDisplayed}`}</span>
                </button>
            )}
        </LoadMoreButtonContainer>
    )
}
